import { all } from 'redux-saga/effects';
import reviews from './reviews';

export const reviewsSaga = function* root() {
  yield all([reviews()]);
};
